import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { PropertyService } from '../service/property.service';
import { DialogModule } from 'primeng/dialog';
import { CreatePropertyComponent } from '../create-property/create-property.component';
import { LoginService } from '../../login/login.service';
@Component({
  selector: 'app-properties',
  standalone: true,
  imports: [TableModule, ButtonModule, CommonModule, DialogModule, CreatePropertyComponent],
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.scss'],
})
export class PropertiesComponent {
  properties = [];
  position: 'center' | 'right' = 'center';
  visible: boolean = false;
  selectedProperty: any | null = null;
  displaySidebar: boolean = false;
  showCancelDialog: boolean = false;
  showDeleteDialog: boolean = false;
  propertyToDelete: any = null;
  showDialog(position: 'right'): void {
    this.position = position;
    this.visible = true;
  }
  constructor(private router: Router, private propertyService: PropertyService, private loginService: LoginService) { }

  ngOnInit() {
    this.getAllProperties();
  }

  navigateToCreateProperty() {
    this.router.navigate(['/create-property']);
  }

  getAllProperties() {
    this.propertyService.getAllProperties().subscribe({
      next: (res) => (this.properties = res),
      error: (err) => console.error('Error fetching properties', err),
    });
  }

  showDialogForEdit(position: 'right', property: any): void {
    this.position = position;
    this.selectedProperty = property;
    this.visible = true;
  }

  confirmDelete(property: any): void {
    this.propertyToDelete = property;
    this.showDeleteDialog = true;
  }

  onDialogClose(): void {
    this.visible = false;
    this.selectedProperty = null;
  }

  declineCancel(): void {
    this.showCancelDialog = false;
  }

  confirmCancel(): void {
    this.displaySidebar = false;
    this.showCancelDialog = false;
  }

  impersonateToLandlordPortal(property: any): void {
    this.propertyService.impersonateToLandlordPortal(property._id).subscribe({
      next: (res: any) => {
        if (res && res.redirectUrl) {
          console.log('Impersonation Response:', res);
          window.location.href = `https://${res.redirectUrl}`;
        } else {
          console.error('Impersonation URL not found in response');
        }
      },
      error: (err) => console.error('Error during impersonation', err),
    });
  }
}
